"use client";

import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCode, faFilter } from "@fortawesome/free-solid-svg-icons";
import WebRealisationCard from "../../components/WebRealisationCard";
import tabWebRealisations from "../../lib/data/dataWeb";
import AnimatedSection from "../../components/AnimatedSection";
import Breadcrumbs from "../../components/Breadcrumbs.jsx";

export default function ProjetsClient() {
  const [selectedType, setSelectedType] = useState("all");
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  // Filtrer les projets par type
  const filteredProjects =
    selectedType === "all"
      ? tabWebRealisations
      : tabWebRealisations.filter((project) => project.type === selectedType);

  // Types disponibles
  const types = ["all", ...new Set(tabWebRealisations.map((p) => p.type))];
  const typeLabels = {
    all: "Tous",
    web: "Applications Web",
    devops: "DevOps & Cloud",
    mobile: "Mobile",
  };

  return (
    <div className=" mx-10 px-4 my-10">
      <div className="flex">
        <main id="main">
          <Breadcrumbs currentPage="Projets" />

          {/* Header */}
          <div className="text-left mb-12">
            <h1 className="text-4xl mb-4 mt-10 flex items-center justify-start">
              <FontAwesomeIcon icon={faCode} className="w-12 h-12 mr-4 " />
              Projets, réalisations, références & cas clients
            </h1>
            <p className=" text-gray-600">
              Découvrez une sélection de mes projets pro ou perso : applications
              web modernes, infrastructures cloud et projets DevOps.
            </p>
          </div>

          {/* Filtres */}
          <div className="mb-8 flex items-center justify-start">
            <div className="inline-flex items-center space-x-2 bg-gray-100 rounded-lg p-1">
              <FontAwesomeIcon icon={faFilter} className="text-gray-500 ml-2" />
              {types.map((type) => (
                <button
                  key={type}
                  onClick={() => setSelectedType(type)}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                    selectedType === type
                      ? "bg-bleuciel text-white"
                      : "text-gray-700 hover:bg-white hover:text-blue-600"
                  }`}>
                  {typeLabels[type]}
                  {type === "all" && `(${tabWebRealisations.length})`}
                  {type !== "all" &&
                    `(${
                      tabWebRealisations.filter((p) => p.type === type).length
                    })`}
                </button>
              ))}
            </div>
          </div>

          {/* Grille des projets */}
          {isClient ? (
            <AnimatedSection className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredProjects.map((data) => (
                <div
                  key={`project_${data.id}`}
                  className="transform hover:scale-105 transition-transform duration-300">
                  <WebRealisationCard data={data} />
                </div>
              ))}
            </AnimatedSection>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredProjects.map((data) => (
                <div
                  key={`project_${data.id}`}
                  className="transform hover:scale-105 transition-transform duration-300">
                  <WebRealisationCard data={data} />
                </div>
              ))}
            </div>
          )}

          {/* Message si aucun projet */}
          {filteredProjects.length === 0 && (
            <div className="text-center py-20">
              <p className="text-gray-500 text-lg">
                Aucun projet trouvé dans cette catégorie.
              </p>
            </div>
          )}

          {/* Statistiques */}
          <div className="mt-16 bg-gray-50 rounded-lg p-8">
            <div className="grid md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="text-3xl font-bold text-blue-600 mb-2">
                  {tabWebRealisations.length}
                </div>
                <div className="text-gray-600">Projets présentés</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-blue-600 mb-2">
                  {
                    new Set(
                      tabWebRealisations.flatMap((p) => p.technos.split(", ")),
                    ).size
                  }
                </div>
                <div className="text-gray-600">Technologies maîtrisées</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-blue-600 mb-2">
                  {new Set(tabWebRealisations.map((p) => p.type)).size}
                </div>
                <div className="text-gray-600">Domaines d&apos;expertise</div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
